import * as React from 'react';
import { snap, story, visualize } from 'storybook-snapper';
import { Ribbon, RibbonShape } from '..';
import { classes } from './Ribbon.visual.st.css';

visualize('Ribbon', () => {
  story('simple', () => {
    snap('default props', <Ribbon>On Sale</Ribbon>);
    snap(
      'with shape = square',
      <Ribbon shape={RibbonShape.Square}>On Sale</Ribbon>,
    );
    snap(
      'Adaptive to Style overrides',
      <Ribbon className={classes.defaultStylesOverride}>On Sale</Ribbon>,
    );
    snap(
      'wst theme',
      <div
        style={
          {
            '--wst-primary-background-color-rgb': '220,00,20',
            '--wst-links-and-actions-color-rgb': '00,220,200',
            '--wst-paragraph-2-font-family': 'Courier New',
            '--wst-paragraph-2-font-size': '22px',
            '--wst-paragraph-2-font-weight': '900',
            '--wst-paragraph-2-font-variant': 'small-caps',
            '--wst-paragraph-2-font-style': 'italic',
            '--wst-paragraph-2-line-height': '3',
          } as React.CSSProperties
        }
      >
        <Ribbon shape={RibbonShape.Square}>
          On Sale On Sale On Sale On Sale
        </Ribbon>
      </div>,
    );
  });
});
